"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightModeLTL = void 0;
exports.FreightModeLTL = {
    LTL: 'LTL'
};
//# sourceMappingURL=freight-mode-ltl.js.map